/*
  Calendar dates in this app are plain YYYY-MM-DD strings. A leave on the 28th
  is the 28th — there is no time and no timezone attached to it, and the
  database column is a DATE, not a timestamptz.

  The trap: `new Date(y, m, d)` builds LOCAL midnight, and `.toISOString()`
  then converts that instant to UTC. Anywhere east of Greenwich the date rolls
  BACK a day. In Asia/Calcutta (UTC+5:30):

      new Date(2026, 7, 28).toISOString()  ->  "2026-08-27T18:30:00.000Z"
                                                          ^^ the 27th

  That is exactly what shifted every entry one cell to the right on the leave
  calendar: the cell labelled 29 was asking the data for leaves dated the 28th,
  so a leave applied for the 28th rendered on the 29th, for everyone.

  These helpers never touch UTC. They read the local calendar fields and build
  the string directly, which is the only correct way to turn a date the user is
  looking at into the key the data is stored under.

  Use `toISOString()` only for real instants — a message timestamp, an export
  filename — never for a date somebody picked off a calendar.
*/

const pad = (n) => String(n).padStart(2, "0");

/** YYYY-MM-DD from a year, a zero-based month and a day — no Date involved. */
export const isoDate = (year, month, day) => `${year}-${pad(month + 1)}-${pad(day)}`;

/** The local calendar date of a Date object, as YYYY-MM-DD. */
export const toLocalISODate = (d) => isoDate(d.getFullYear(), d.getMonth(), d.getDate());

/** Today in the viewer's own timezone — the date on their wall calendar. */
export const todayISO = () => toLocalISODate(new Date());
